export const modules = {
  WxuHeaderMobile: {
    clientLoader: () => import(/* webpackChunkName: "HeaderMobile" */'@wxu/modules/src/HeaderMobile/client.loader').then(module => module.clientLoader),
  },
  WxuNavigation: {
    clientLoader: () => import(/* webpackChunkName: "Navigation" */'@wxu/modules/src/Navigation/client.loader').then(module => module.clientLoader),
  },
  WxuDsrForm: {
    clientLoader: () => import(/* webpackChunkName: "DsrForm" */'@wxu/modules/src/DsrForm/client.loader').then(module => module.clientLoader),
  },
  WxuFooter: {
    clientLoader: () => import(/* webpackChunkName: "Footer" */'@wxu/modules/src/Footer/client.loader').then(module => module.clientLoader),
  },
  WxuLocalsuiteNav: {
    clientLoader: () => import(/* webpackChunkName: "LocalsuiteNav" */'@wxu/modules/src/LocalsuiteNav/client.loader').then(module => module.clientLoader),
  },
  WxuHeaderLargeScreen: {
    clientLoader: () => import(/* webpackChunkName: "HeaderLargeScreen" */'@wxu/modules/src/HeaderLargeScreen/client.loader').then(module => module.clientLoader),
  },
  WxuSavedLocations: {
    clientLoader: () => import(/* webpackChunkName: "SavedLocations" */'@wxu/modules/src/SavedLocations/client.loader').then(module => module.clientLoader),
  },
  WxuPrivacyDataNotice: {
    clientLoader: () => import(/* webpackChunkName: "PrivacyDataNotice" */'@wxu/modules/src/PrivacyDataNotice/client.loader').then(module => module.clientLoader),
  },
  WxuPrivacyDataInventory: {
    clientLoader: () => import(/* webpackChunkName: "PrivacyDataInventory" */'@wxu/modules/src/PrivacyDataInventory/client.loader').then(module => module.clientLoader),
  },
  WxuDSRGlossary: {
    clientLoader: () => import(/* webpackChunkName: "DSRGlossary" */'@wxu/modules/src/DSRGlossary/client.loader').then(module => module.clientLoader),
  },
  WxuDataPartners: {
    clientLoader: () => import(/* webpackChunkName: "DataVendors" */'@wxu/modules/src/DataVendors/client.loader').then(module => module.clientLoader),
  },
  WxuPrivacyPolicyToast: {
    clientLoader: () => import(/* webpackChunkName: "PrivacyPolicyToast" */'@wxu/modules/src/PrivacyPolicyToast/client.loader').then(module => module.clientLoader),
  },
  WxuPrivacyPolicyDirectory: {
    clientLoader: () => import(/* webpackChunkName: "PrivacyPolicyDirectory" */'@wxu/modules/src/PrivacyPolicyDirectory/client.loader').then(module => module.clientLoader),
  },
  WxuPrivacySettings: {
    clientLoader: () => import(/* webpackChunkName: "PrivacySettings" */
      '@wxu/modules/src/PrivacySettings/client.loader'
    ).then(module => module.clientLoader),
  },
  WxuWebViewPrivacySettings: {
    clientLoader: () => import(/* webpackChunkName: "WebViewPrivacySettings" */'@wxu/modules/src/WebViewPrivacySettings/client.loader').then(module => module.clientLoader),
  },
  WxuPollCard: {
    clientLoader: () => import(/* webpackChunkName: "InsightBentoCard" */'@wxu/modules/src/Poll/client.loader').then(module => module.clientLoader),
  },
  WxuPrivacyConsentModal: {
    clientLoader: () => import(/* webpackChunkName: "WxuPrivacyConsentModal" */'@wxu/modules/src/PrivacyConsentModal/client.loader').then(module => module.clientLoader),
  },
  LiteContent: {
    clientLoader: () => import(/* webpackChunkName: "LiteContent" */'@wxu/modules/src/LiteContent/client.loader').then(module => module.clientLoader),
  },
  WxuDataPurposes: {
    clientLoader: () => import(/* webpackChunkName: "DataPurposes" */'@wxu/modules/src/DataPurposes/client.loader').then(module => module.clientLoader),
  },
  // APPEND_MODULE
};
